export enum PayloadDirection {
  CLOUDTODEVICE = 'CLOUDTODEVICE',

  DEVICETOCLOUD = 'DEVICETOCLOUD',
}
